export default __webpack_public_path__ + "static/media/hoppia_events_logo.9664693a.svg";